export default __webpack_public_path__ + "static/media/exam-410-small.734a0367.png";